// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_MODEL_LIST,
} from './constants';

export function updateModelList(text) {
  return {
    type: CAR_DATA_MASTER_UPDATE_MODEL_LIST,
    text: text
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_MODEL_LIST:
      let aux = [...state.modelListOrigin];
      aux = aux.filter(model => model.code.toLowerCase().includes(action.text.toLowerCase()) || model.name.toLowerCase().includes(action.text.toLowerCase()) || model.brand_name.toLowerCase().includes(action.text.toLowerCase()));
      return {
        ...state,
        modelList: [...aux]
      };

    default:
      return state;
  }
}
